import type { PropDefaults, PropElement, PropTypes } from "@platform/react-storybook/Component";

import type { PropTypesVerticalCardsSection } from "@front/components/Section/Card/Vertical/types";

import Namespace from "./_index.scss";

export const { NAME_PREVIEW, TYPE_PREVIEW } = Namespace;

export type PropPreview = PropElement & {
    "list-cards": PropTypesVerticalCardsSection;
};

export const DEF_PREVIEW: PropDefaults<PropPreview> = {};

export type PropTypesPreview = PropTypes<PropPreview, typeof DEF_PREVIEW>;
